module.exports = "<div *ngIf=\"EventController.dataForm.commentary && showSlotCommentary\" class=\"slots_remaining\">\n  <span>{{EventController.dataForm.commentary}}</span>\n  <button (click)=\"showSlotCommentary = false\" title=\"{{EventController.dataForm.commentary}}\"></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/register-event/view/slot-display-commentary/slot-display-commentary.component.html
// module id = ./src/app/screens/register-event/view/slot-display-commentary/slot-display-commentary.component.html
// module chunks = main